import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Img1 from "./aa.png";
import Img2 from "./background2.png";
import Img21 from "./Frame44.png";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  CardMedia,
  Slide,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Logo from "./vertex_suite_logo.png";
import { MdMenu } from "react-icons/md";
import HeaderSliderMobile from "./HeaderSliderMobile";
import HeaderDesktop from "./HeaderDesktop";
import backImg from "./headerBackground.png";
import backImg1 from "./backgroundIMg121.webp";

const Header = () => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate("/");
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = (scrollTop / docHeight) * 100;
      setScrollProgress(scrolled);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 30) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll, { passive: true });
    };
  }, []);

  const theme = useTheme();
  const isLgOrXl = useMediaQuery(theme.breakpoints.up("lg"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Detect mobile view

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen((prev) => !prev); // Toggle the sidebar
  };

  return (
    <Stack
      sx={{
        display: { xl: "flex" },
        flexDirection: { xl: "row", lg: "row" },
        justifyContent: { xl: "center", lg: "center", md: "column" },
        position: "sticky",
        top: 0,
        zIndex: 1000,
        background: scrolled ? "none" : "#f8fafc",
        height: { xl: "68px", lg: "68px", md: "68px", sm: "56px", xs: "64px" },
        // border: "2px solid red",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          width: { xl: scrolled ? "32%" : "70%", lg: scrolled ? "36%" : "80%" },
          backgroundColor: scrolled
            ? "rgba(255, 255, 255, 0.5)" // Increased transparency
            : "none",
          backdropFilter: scrolled ? "blur(12px)" : "none", // Frosted glass effect
          borderRadius: {
            xl: scrolled ? (isMobile ? "0px" : "16px") : "0px",
            lg: scrolled ? (isMobile ? "0px" : "16px") : "0px",
            md: scrolled ? (isMobile ? "0px" : "0px") : "0px",
          }, // Slightly rounded corners
          boxShadow: scrolled
            ? "0 8px 32px rgba(0, 0, 0, 0.1)" // Enhanced shadow for depth
            : "none",
          border: scrolled ? "1px solid rgba(#e1e1e2, 0.2)" : "none", // Light border for separation
          transition: "all 0.5s ease-in-out", // Smooth transitions
          // border: "1px solid red",
        }}
      >

        <Stack
          sx={{
            height: { md: "96%", lg: "100%", xl: "100%" },
            width: { lg: "120px", xl: "198px" },
            // border: "1px solid red",
            display: "flex",
            flexDirection: "row",
            justifyContent: {
              xl: "flex-start",
              lg: "flex-start",
              md: "center",
              sm: "center",
              xs: "center",
            },
            alignItems: "center",
            position: "relative",
            top: { xl: "0px", lg: "0px", md: "2px", sm: "0px" },
            left: { xl: "0px", lg: "0px", md: "24px", sm: "0px", xs: "0px" },
          }}
          onClick={handleClick}
        >
          <CardMedia
            component="img"
            image={Logo}
            alt="logo"
            sx={{
              height: isMobile ? "40px" : scrolled ? "52px" : "64px",
              width: isMobile ? "48px" : scrolled ? "58px" : "68px",
              objectFit: "contain",
            }}
          />
        </Stack>
        {isLgOrXl ? (
          <HeaderDesktop scrolled={scrolled} />
        ) : (
          <Button onClick={handleMobileMenuToggle}>
            <MdMenu size={24} />
          </Button>
        )}
      </Toolbar>
      <Stack // 👇 Scroll progress bar here
        sx={{
          display: { xs: "block", sm: "block", md: "none" },
          height: "8px",
          backgroundColor: "#eee",
          position: "sticky",
          top: "56px",
          zIndex: 999,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            height: "100%",
            backgroundColor: "rgb(33 134 192)",
            width: `${scrollProgress}%`,
            transition: "width 0.1s linear",
          }}
        />
      </Stack>
      {/* Sidebar for mobile view */}
      {mobileMenuOpen && (
        <HeaderSliderMobile
          mobileMenuOpen={mobileMenuOpen}
          handleMobileMenuToggle={handleMobileMenuToggle}
        />
      )}
    </Stack>
  );
};

export default Header;
